export const SET_BLACKLISTS = "SET_BLACKLISTS";
export const ADD_BLACKLIST = "ADD_BLACKLIST";
export const REMOVE_BLACKLIST = "REMOVE_BLACKLIST";
export const UPDATE_BLACKLIST = "UPDATE_BLACKLIST";